function TwitterIcon({ size = "24", color = "#b1272c" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 28.003 22.743"
    >
      <path
        id="Icon_awesome-twitter"
        data-name="Icon awesome-twitter"
        d="M25.124,9.049c.018.249.018.5.018.746,0,7.587-5.775,16.329-16.329,16.329A16.218,16.218,0,0,1,0,23.548a11.873,11.873,0,0,0,1.386.071,11.494,11.494,0,0,0,7.125-2.452,5.749,5.749,0,0,1-5.366-3.98,7.237,7.237,0,0,0,1.084.089,6.07,6.07,0,0,0,1.51-.2,5.74,5.74,0,0,1-4.6-5.633v-.071a5.78,5.78,0,0,0,2.594.728A5.748,5.748,0,0,1,1.954,4.429a16.313,16.313,0,0,0,11.834,6.006,6.479,6.479,0,0,1-.142-1.315,5.745,5.745,0,0,1,9.932-3.927,11.3,11.3,0,0,0,3.642-1.386A5.724,5.724,0,0,1,24.7,6.97,11.505,11.505,0,0,0,28,6.082a12.337,12.337,0,0,1-2.878,2.967Z"
        transform="translate(0 -3.381)"
        fill={color}
      />
    </svg>
  );
}

export default TwitterIcon;
